import { useStoreTransactionHistory } from '~/stores/softswiss/transactionHistory';
import { getCookieValue, rootDomain } from '~/utils/cookie';

export const useCookieUserType = () => {
  const init = () => {
    if (!window || !import.meta.browser) {
      return;
    }

    const userType = getCookieValue('UserType');

    if (userType && userType === 'DepN') {
      return;
    }

    const domain = rootDomain(document.location.hostname);

    window.document.cookie = `UserType=Dep0;Max-Age=63158400;Domain=${domain};Path=/`;
  };

  const check = () => {
    const domain = rootDomain(document.location.hostname);
    const userType = getCookieValue('UserType');

    if (userType && userType === 'DepN') {
      return;
    }

    const isDep = useStoreTransactionHistory().payments.some((item) => item.success);

    if (isDep) {
      window.document.cookie = `UserType=DepN;Max-Age=63158400;Domain=${domain};Path=/`;
    } else {
      window.document.cookie = `UserType=Dep0;Max-Age=63158400;Domain=${domain};Path=/`;
    }
  };

  return {
    init,
    check,
  };
};
